import HomeCard from "./HomeCard";

export default function Home({
  onReturn,
  onReception,
  onViewReturns,
  onViewProcessedReturns,
  onViewReceptions,
  rc,
  prc,
  rec,
  isAdmin,
  onAdmin,
}) {
  return (
    <div style={{ textAlign: "center" }}>
      <h1
        style={{
          fontSize: "42px",
          fontFamily: "'Space Grotesk', sans-serif",
          fontWeight: "700",
          marginBottom: "16px",
        }}
      >
        <span className="glow">Kjøretøyportal</span>
      </h1>
      <p
        style={{
          fontSize: "18px",
          color: "rgba(255,255,255,0.6)",
          marginBottom: "48px",
        }}
      >
        Registrer mottak eller tilbakelevering av kjøretøy
      </p>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "24px",
        }}
      >
        <HomeCard
          title="Mottak av ny bil"
          desc="Registrer mottak av nytt kjøretøy"
          icon="+"
          gradient="linear-gradient(135deg, #00d4aa 0%, #00a8cc 100%)"
          onClick={onReception}
        />
        <HomeCard
          title="Registrer bilretur"
          desc="Registrer tilbakelevering"
          icon="↩"
          gradient="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
          onClick={onReturn}
        />
        <HomeCard
          title="Mottatte biler"
          desc="Se tidligere mottak"
          icon="📋"
          gradient="linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
          onClick={onViewReceptions}
          count={rec}
        />
        <HomeCard
          title="Returnerte biler"
          desc="Se aktive returer"
          icon="📄"
          gradient="linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
          onClick={onViewReturns}
          count={rc}
        />
        <HomeCard
          title="Behandlede returer"
          desc="Se ferdigbehandlede returer"
          icon="🗃️"
          gradient="linear-gradient(135deg, #43cea2 0%, #185a9d 100%)"
          onClick={onViewProcessedReturns}
          count={prc}
        />
        {isAdmin && (
          <HomeCard
            title="Administrasjon"
            desc="Administrer bedrifter og brukere"
            icon="⚙️"
            gradient="linear-gradient(135deg, #f7971e 0%, #ffd200 100%)"
            onClick={onAdmin}
          />
        )}
      </div>
    </div>
  );
}
